import { useLocation, useParams } from 'react-router';
import Uuid from '../../../model/Uuid';
import { TerminListAdminFilter } from '../../../model/TerminListAdminFilter';
import { Pouzivatel } from '../../../model/Pouzivatel';
import useAutorZmenyList from '../../../hooks/useAutorZmenyList';

const mapSearchText = (searchText: string): string => {
  if (searchText && searchText.trim().length > 0) {
    return searchText;
  }
  return '';
};

const mapPouzivatel = (pouzivatelUuid: Uuid, pouzivatelia: Pouzivatel[]): Pouzivatel => {
  if (pouzivatelia == null || pouzivatelia.length === 0) {
    return undefined;
  }
  return pouzivatelia.filter(pouzivatel => pouzivatel.uuid === pouzivatelUuid)[0];
};

const parseBooleanValue = (value: string): boolean | undefined => {
  switch (value) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return undefined;
  }
};

interface ReturnType {
  initialFilter: TerminListAdminFilter;
  initialFilterLoading: boolean;
  initialFilterFinished: boolean;
}

export default (): ReturnType => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();

  const {
    pouzivatelia,
    pouzivateliaStatus,
  } = useAutorZmenyList(tezaurusUuid);

  return {
    initialFilter: {
      hladanyTermin: mapSearchText(search.get('hladanyTermin')),
      publikovany: parseBooleanValue(search.get('publikovany')),
      autorPoslednejZmeny: mapPouzivatel(
        mapSearchText(search.get('autorPoslednejZmenyUuid')),
        pouzivatelia,
      ),
    },
    initialFilterLoading: pouzivateliaStatus.loading,
    initialFilterFinished: pouzivateliaStatus.finished,
  };
};
